export const EDIT_REASONS = [
  'MISSPELLING',
  'NEW_INFORMATION',
  'ISSUE_RESOLVED',
  'APPROACHED_BY_PARTNER',
  'OTHER',
];
